import VatIdentifierValidator from 'Services/VatIdentifierValidator';

/**
* Used by Cart Pricing v3
*/
export default {
    computed: {
        samIntraVatRules () {
            return {
                vatIdentificationNumber: [{
                    required: false,
                    message: Loc.g('Veuillez renseigner un identifiant de TVA intracommunautaire valide'),
                    trigger: 'change'
                }, {
                    validator: this.checkVatIdentifierNumber,
                    trigger: 'change'
                }],
            }
        },
    },
    methods: {
        /**
         * @requires null|string PROP/DATA/COMPUTED NAMED "countryCode"
         */
        checkVatIdentifierNumber(rule, value, callback) {
            // is countryCode prop defined
            if (value === '') callback();
            if (this.countryCode === undefined) callback();

            // countryCode must be either null or a string
            if (!(null === this.countryCode || _.isString(this.countryCode))) throw new Error(Loc.g('Aucun pays sélectionné'));

            let validator = new VatIdentifierValidator(this.countryCode);
            if (!validator.isValid(value)) {
                callback(new Error(Loc.g('Le format du n° de tva ne correspond pas à celui du pays sélectionné')));
            }
            callback();
        }
    }
}